module.exports = __webpack_public_path__ + "static/media/icon-quality-red.c274970b.svg";